import { useEffect, useState } from "react";
import { AiOutlineArrowUp, AiOutlineArrowDown } from "react-icons/ai";
import { decryptor, getPayloadHash } from "../../services/helper";
import { getLocalToken } from "../../services/token";
import { postFormDataCall } from "../../services/apiCall";
import SkeletonWallet from "../../Components/Loader/Skeleton/WalletSkeleton";

const CompanyWallet = () => {
  const [balance, setBalance] = useState(0);
  const [history, setHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const transactions = [
    { id: 1, type: "credit", amount: 500, date: "2024-03-15" },
    { id: 2, type: "debit", amount: 200, date: "2024-03-12" },
    { id: 3, type: "credit", amount: 350, date: "2024-03-10" },
  ];

  const getWallet = async () => {
    setIsLoading(true);

    const token = getLocalToken();
    let userInfo = decryptor({ encryptedData: token });
    if (!userInfo) return null;

    userInfo = JSON.parse(userInfo);

    const payload = {
      user_id: userInfo?.user_id,
    };
    const dataToSend = getPayloadHash({ data: payload });
    let response = await postFormDataCall(
      "/get-wallet-balance",
      {},
      { data: dataToSend }
    );

    if (response?.success && response?.data) {
      setBalance(Number(response.data?.balance));
      setHistory(response?.data?.transactions);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getWallet();
  }, []);

  return (
    <>
      <h1 className="text-3xl font-semibold sticky top-0 bg-white z-40 py-3 border-b border-gray-300">
        Wallet
      </h1>
      {isLoading ? (
        <SkeletonWallet />
      ) : (
        <>
          <div className="w-full mx-auto py-4">
            <div className="py-2">
              <h2 className="text-xl font-semibold text-gray-800">Balance</h2>
              <p className="text-3xl font-bold text-green-600 mt-2">
                ₹{balance?.toFixed(2)}
              </p>
              <div className="flex gap-3 mt-4">
                {/* <button className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg">
                  <AiOutlinePlusCircle size={18} /> Add Funds
                </button> */}
                <button className="flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg">
                  <AiOutlineArrowDown size={18} /> Withdraw
                </button>
              </div>
            </div>

            <div className="mt-6 rounded-md border border-gray-300 py-4">
              <h3 className="text-lg font-bold text-gray-900 px-6">
                Transactions History
              </h3>
              <div className="bg-white mt-3 px-4">
                {history.map((tx, index) => (
                  <div
                    key={`${tx.id}-${index}`}
                    className="flex justify-between items-center py-2 border-b last:border-b-0"
                  >
                    <div className="flex items-center gap-2">
                      {tx.type === "credit" ? (
                        <AiOutlineArrowUp
                          className="text-green-500"
                          size={18}
                        />
                      ) : (
                        <AiOutlineArrowDown
                          className="text-red-500"
                          size={18}
                        />
                      )}
                      <p className="text-gray-600">
                        {new Date(tx.created_at).toUTCString()}
                      </p>
                    </div>
                    <p
                      className={`font-medium text-lg ${
                        tx.type === "credit" ? "text-green-600" : "text-red-600"
                      }`}
                    >
                      {tx.type === "credit" ? "+" : "-"}₹
                      {Number(tx.amount).toFixed(2)}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
      {/* <PopupWrapper open={confirmOpen}>
            <div className="w-full sm:w-1/2 lg:w-1/3 h-1/4 rounded-lg bg-white flex flex-col justify-between p-5 shadow-2xl shadow-gray-800">
              <div className="flex">
                <div className="flex flex-col gap-1">
                  <h6 className="text-xl font-bold text-gray-900">
                    Update Profile
                  </h6>
                  <p className="text-gray-700">
                    Are you sure you want to update your profile ?
                  </p>
                </div>
              </div>
    
              <div className="w-full flex items-center justify-end gap-2">
                <button
                  type="button"
                  className="w-20 py-1.5 rounded-lg bg-blue-50 text-blue-500 border border-blue-500 hover:scale-105 transition-all duration-150"
                  onClick={() => setConfirmOpen(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="w-24 py-1.5 rounded-lg bg-blue-500 text-white border border-blue-500 hover:scale-105 transition-all duration-150"
                  onClick={() => {
                    updateProfile();
                    setConfirmOpen(false);
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </PopupWrapper> */}
    </>
  );
};

export default CompanyWallet;
